import { render, staticRenderFns } from "./DetailsList.vue?vue&type=template&id=74454c11&"
import script from "./DetailsList.vue?vue&type=script&setup=true&lang=js&"
export * from "./DetailsList.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DetailsList.vue?vue&type=style&index=0&id=74454c11&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports